import { Routes, Route} from "react-router-dom";
import AbsenceComponent from '../AbsenceComponent';
import AbsenceDetails from '../AbsenceDetailsComponent';
import UserAuswahl from './UserAuswahl';
function MitarbeiterAbwesenheit(props) {
  const {client, accessToken, updateTitle, location} = props;

  return (
    <Routes>
        <Route path="/PMURA1/antragdetailsuser/:antragid" element={<AbsenceDetails updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} />} />
        <Route path="/PMURA1/*" element={<AbsenceComponent updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} />}/>  
        <Route path="/" element={<UserAuswahl client={client} accessToken={accessToken} updateTitle={updateTitle} location={location} />} />
    </Routes> 
  );
}

export default MitarbeiterAbwesenheit;
